import {Link} from 'react-router-dom';

export default function ALink({to, href, children, style, className,...args}) {
  // console.log(
  //   {
  //     info:"Alink",
  //     to,
  //     href
  //   }
  // )
  if (!!to) {
    return (<Link
      to={to}
      className={className}
      style={style}
      {...args}
            >
      {children}
    </Link>)
  }
  return (<a
    target="_blank"
    rel="noreferrer"
    href={href}
    className={className}
    style={style}
    {...args}
          >
    {children}
  </a>)
}
